import {
  assignIfExists,
  findResultByEvent,
  mapResults,
  removeItemByCodeAndEvent,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import subscribersResult, { newSubscribersList } from './state';

const fetchSubscribers = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.subscribers[action.category].results.push({
      ...newSubscribersList(action.code, action.event),
      readStatus: states.PENDING,
    });
  }
});

const showSubscribers = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, subscribersResult)
    : mapResults([], action, subscribersResult);
  item.name = action.name;
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showSubscribersError = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const updateSubscribersFilter = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  item.filter = action.value;
});

const updateSubscribersRoleFilter = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  item.role = action.role;
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.currentPage = 1;
});

const closeSubscribers = withDraft((draft, action) => {
  const item = findResultByEvent(draft.subscribers, action, action.event);
  if (item?.code && item.event) {
    draft.subscribers[action.category].results = removeItemByCodeAndEvent(
      draft.subscribers[action.category].results,
      item,
    );
  } else if (item) {
    assignIfExists(item, newSubscribersList(null, null));
  }
});

export default {
  [actions.CLOSE_SUBSCRIBERS]: closeSubscribers,
  [actions.FETCH_SUBSCRIBERS]: fetchSubscribers,
  [actions.REFRESH_SUBSCRIBERS]: fetchSubscribers,
  [actions.SHOW_SUBSCRIBERS]: showSubscribers,
  [actions.SHOW_SUBSCRIBERS_ERROR]: showSubscribersError,
  [actions.UPDATE_SUBSCRIBERS_FILTER]: updateSubscribersFilter,
  [actions.UPDATE_SUBSCRIBERS_ROLE_FILTER]: updateSubscribersRoleFilter,
};
